import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Layers } from 'lucide-react';

const ProductsSection = ({ products }) => {
  return (
    <div className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold mb-4">
            Our Products
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Premium Bitumen Products
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Wide range of high-quality bitumen grades for diverse applications
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <Card 
              key={index}
              className="group hover:shadow-2xl transition-all duration-500 border-2 border-slate-200 hover:border-amber-500 bg-white overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-amber-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              
              <CardHeader className="pb-4">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-14 h-14 rounded-xl bg-amber-100 flex items-center justify-center group-hover:bg-amber-600 transition-colors duration-300">
                    <Layers className="w-7 h-7 text-amber-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {product.grades.map((grade, idx) => (
                      <Badge 
                        key={idx}
                        variant="secondary"
                        className="bg-slate-100 text-slate-700 hover:bg-amber-600 hover:text-white transition-colors duration-300"
                      >
                        {grade}
                      </Badge>
                    ))}
                  </div>
                </div>
                <CardTitle className="text-2xl font-bold text-slate-900 group-hover:text-amber-600 transition-colors duration-300">
                  {product.name}
                </CardTitle>
                <CardDescription className="text-base text-slate-600 mt-2">
                  {product.description}
                </CardDescription>
              </CardHeader>
              
              <CardContent>
                <div className="space-y-2">
                  <p className="text-sm font-semibold text-slate-700 mb-3">Applications:</p>
                  <div className="flex flex-wrap gap-2">
                    {product.applications.map((app, idx) => (
                      <span 
                        key={idx}
                        className="px-3 py-1 rounded-full bg-slate-100 text-slate-700 text-sm font-medium group-hover:bg-amber-50 group-hover:text-amber-700 transition-colors duration-300"
                      >
                        {app}
                      </span>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsSection;
